import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

// Every purchase goes straight to Stripe Checkout, which shows card, wallets and bank transfer when supported.
export function askPayMethod() {
  toast.loading("Apertura checkout sicuro…", { id: "sq-checkout", duration: 8000 });
  return Promise.resolve("stripe");
}

export function MyBankOrders() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/bank-orders").then(({ data }) => setRows(data.orders || [])).catch(() => {}); }, []);
  const list = rows.filter((o) => o.status !== "annullato").slice(0, 5);
  if (!list.length) return null;
  return (
    <section data-testid="my-bank-orders" className="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
      <p className="font-semibold mb-2">I tuoi ordini con bonifico</p>
      {list.map((o) => (
        <a key={o.id} data-testid={`my-bank-order-${o.number}`} href={`/ordine-bonifico/${o.id}?t=${o.token}`} className="flex justify-between gap-3 py-2 border-t border-white/10 text-sm hover:text-[#3BE477]">
          <span className="min-w-0">{o.number} · {o.label}</span><span className="shrink-0 whitespace-nowrap">{o.total} · <b className={o.status === "pagato" ? "text-[#3BE477]" : "text-amber-300"}>{o.status_label}</b></span>
        </a>))}
    </section>
  );
}
